import React from 'react';
import { Link } from 'react-router-dom';
import { IcoSettings, IcoHome } from '../components/component';


export default function Footer({ onToggleTheme }) {
    return (
        <div className="footer-container">
            <footer className="footer">
                <div className='flx-Hc-2'>
                    <p>&copy; 2024-2025 colorspace.cloud - All rights reserved.</p>
                    <p>Privacy Policy | Terms of Service</p>
                    <p>FAQ</p>
                    <p>Contact</p>
                </div>
                <div className='flx-Hc-2'>
                    <Link to='/home'>
                        <IcoHome iconSize={20} labelText='Home' />
                    </Link>
                    <Link onClick={onToggleTheme}>
                        <IcoSettings iconSize={20} labelText='Night&Day' />
                    </Link>
                </div>
            </footer>
        </div>
    );
}   
